<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="log-send-quickreply-template-block">
      <div class="content-text message-bg" v-if="data && data.text">
        <span>{{data.text}}</span>
      </div>
      <div class="quickreply-wrapper">
        <template v-for="(item, index) in data.items">
          <button
            class="button is-rounded"
            :title="item.payload"
            :key="data.id+'-'+index"
          >{{item.title}}</button>
        </template>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.log-send-quickreply-template-block {
  overflow: hidden;
  .content-text {
    padding: 10px;
    border-radius: 10px 0 10px 10px;
    background-color: #efefef;
    text-align: left;
  }
  .quickreply-wrapper {
    white-space: nowrap;
    overflow-x: auto;
    width: inherit;
    padding: 0.6em 0 1.5em 0;
    .button {
      margin-right: 5px;
      font-size: 1em;
    }
  }
}
</style>
